<template>
    <div class="gxjy">
      <jzcgheader></jzcgheader>
      <div class="bgall">
        <div class=" content">
          <el-row :gutter="20"> 
            <el-col :span="15"> 
                  <div class="tuzuo"> 
                    <p class="tzt">智能采购，驱动工业未来</p>
                    <p class="tzp">精选黄骅市工业用品，提供高效、透明的采购服务</p>
                  </div>
            </el-col> 
            <el-col :span="9"> 
                <div class="tuyou"> 
                  <p class="tyt">集采解决方案</p>
                    <p class="tyt2">整合行业力量，优化采购流程，通过集体议价实现质量与成本的双重优化</p>
                </div>
            </el-col> 
          </el-row>
          <div style="margin-top:30px;"> 
            <el-row>
              <el-col :span="15"> 
                <div> 
                  <el-input placeholder="搜索集采内容" v-model="inputKey" clearable style="width:98%;">
    <el-button slot="append" type="primary"  @click="btnSearch">搜索</el-button>
  </el-input>
                </div>
              </el-col>  
              <el-col :span="9"> 
                <div style="text-align: right;"> 
<el-button type="primary" style="width:160px;border-radius: 25px;" @click="btnPublish">免费发布</el-button>
                </div>
              </el-col>  
            </el-row>
            <div style="margin-top:30px;" class="neirong"> 
              <el-row :gutter="20"> 
            <el-col :span="15"> 
                  <div style="margin-top: 18px;"> 
                    <p><span @click="btnSearchHangye(item.id)" style="margin-right:25px;cursor: pointer;" class="tt1" v-for="item in zlList" :key="item.id">{{item.name}}</span><span @click="btnSearchHangye()" v-if="zlList.length>0" style="cursor:pointer;">更多></span></p>
                  </div>
                  <div> 
                    <p class="tt2" @click="btnSearchCailiao(fenleiOne.id,'')" >{{fenleiOne.name}}集采</p>
                    <div class="fenge" style=""></div>
                    <p><span @click="btnSearchCailiao(fenleiOne.id,item.id)" style="margin-right:22px;width:100px;height:100px;display: inline-block;position: relative;cursor: pointer;" v-for="item in yclList" :key="item.id">
                      <el-image
      style="width: 100px; height: 100px;border-radius: 10px;"
      :src="item.img"
      :fit="'fill'"></el-image>
                    <span class="jxd" style="position:absolute;bottom:0px;text-align: center;display: block;width:100%;line-height: 24px;color:white;">{{item.name}}</span>
                    </span><span v-if="yclList.length>0" @click="btnSearchCailiao(fenleiOne.id,'')" style="margin-right:0px;width:100px;height:100px;display: inline-block;position: relative;cursor: pointer;" >
                      <el-image
      style="width: 100px; height: 100px;border-radius: 10px;"
      :src="require('../../assets/jzcg/gengduo.png')"
      :fit="'fill'"></el-image>
                    <span style="position:absolute;bottom:0px;text-align: center;display: block;width:100%;line-height: 24px;color:white;">更多</span>
                    </span></p>
                  </div>
                  <div> 
                    <p class="tt2" @click="btnSearchCailiao(fenleiTwo.id,'')">{{fenleiTwo.name}}集采</p>
                    <div class="fenge" style=""></div>
                    <p><span @click="btnSearchCailiao(fenleiTwo.id,item.id)" style="margin-right:22px;width:100px;height:100px;display: inline-block;position: relative;cursor: pointer;" v-for="item in zpList" :key="item.id">
                      <el-image
      style="width: 100px; height: 100px;border-radius: 10px;"
      :src="item.img"
      :fit="'fill'"></el-image>
                    <span class="jxd" style="position:absolute;bottom:0px;text-align: center;display: block;width:100%;line-height: 24px;color:white;">{{item.name}}</span>
                    </span><span v-if="zpList.length>0" @click="btnSearchCailiao(fenleiTwo.id,'')" style="margin-right:0px;width:100px;height:100px;display: inline-block;position: relative;cursor: pointer;" >
                      <el-image
      style="width: 100px; height: 100px;border-radius: 10px;"
      :src="require('../../assets/jzcg/gengduo.png')"
      :fit="'fill'"></el-image>
                    <span style="position:absolute;bottom:0px;text-align: center;display: block;width:100%;line-height: 24px;color:white;">更多</span>
                    </span></p>
                  </div>
            </el-col> 
            <el-col :span="9"> 
                <div> 
                  <div v-if="jcList.length==0" style="height:380px;">
                    <el-empty description="暂无集采需求"></el-empty>
                  </div>
                 
                  <div v-for="item in jcList" :key="item.id" style="display: flex;margin-bottom: 14px;" @click="goDetail(item.id)"> 
                    <div style="width:110px;" > 
                      <el-image
      style="width: 90px; height: 90px;border-radius: 10px;"
    
      :src="item.img==''?require('../../assets/jzcg/moren.png'):item.img"
      :fit="'fill'"></el-image>
                    </div>
                    <div style="flex: 1;"> 
                      <div style="padding:0 0 0 0px;"> 
                        <p class="pp1" style="margin-top:11px;"><span style="display: inline-block;max-width: 240px;" class="ellipsis">{{item.title}}</span></p>
                      <p class="pt1">发起人：{{item.contactPerson}}</p>
                      <p class="pt1">截止时间：{{item.endTime}}</p>
                      </div>
                    </div>
                    <div style="width:80px;text-align: center;"> 
                      <el-button :disabled="item.state==2||item.isMe==true ||item.isEnlists==true" size="small" :type="(item.state==2||item.isMe==true ||item.isEnlists==true)?'info':'primary'" style="margin-top:33px;" @click.stop="btnBaoming(item.id)">报名</el-button>
                    </div>
                  </div>
                  <div style="text-align: center;"> 
                    <el-button size="mini" type="primary" style="width:190px;" @click="btnSeemore">查看更多</el-button>
                  </div>
                </div>
            </el-col> 
          </el-row>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import jzcgheader from './jzcgheader'
// import {supplydemandindex} from "../../request/moudle/jzcg";
import {getCategoryList,getIndustryList,centerpurchasepage} from "../../request/moudle/jizhongcaigou"
import config from "../../utils/config";
export default {
  name: "czcg",
  components:{
    jzcgheader
  },
  data(){
    return {
      userInfo:  this.common.getSessionStorage('userInfo'),
      page:{
        current:1,
        size:9,
        total:0
      },
      ////////////
      zlList:[],//产业列表
      yclList:[],//原材料列表
      zpList:[],//制品列表
      jcList:[],//集采列表
      inputKey:'',//关键字
      fenleiOne:'',
      fenleiTwo:'',
    }
  },
  created() {
  },
  mounted(){
    this.initList();
    
  },
  methods:{
    isImagePath(path) {
    const imageExtensions = /\.(jpg|jpeg|png|gif|bmp|webp)$/i;
    return imageExtensions.test(path);
},
    getFirstPhoto(imgP){
      if(imgP==''){
        return require('../../assets/jzcg/moren.png');
      }else{
       
        let arr=imgP.split(',');
        let imgR=arr.find(item=>{
          return this.isImagePath(item);
        })
        if(imgR!=undefined){
          return imgR
        }else{
          return require('../../assets/jzcg/moren.png');
        }
      }
    },
    //集采详情
    goDetail(id){
      this.$router.push({
        path:'/xvqiuxq',
        query:{id}
      })
    },
    //左侧列表
    initList(){
      getCategoryList().then(res=>{
        const dataOne=res.data[0];
        const dataTwo=res.data[1];
        this.fenleiOne=dataOne;
        this.fenleiTwo=dataTwo;
        this.yclList=dataOne.children;
        this.zpList=dataTwo.children;
      }).catch();
      getIndustryList().then(res=>{
        this.zlList=res.data.slice(0,7);
      }).catch();
      centerpurchasepage({current:0,size:30}).then(res=>{
        this.jcList=res.data.records.filter(item=>{
          return item.isMe!=true;
        }).slice(0,4);
      }).catch();
    },
    login(){
      this.$router.push({
        path:'/login'
      })
    },
    //搜索框
    btnSearch(){
      // this.$message.error('搜索');
      if(this.inputKey==''){

      }else{
        this.$router.push({
        name:'jicailist',
        params:{
          keyword:this.inputKey
        }
      })
      }
    
    },
    btnSearchHangye(type){
      this.$router.push({
        name:'jicailist',
        params:{
          industry:type
        }
      })
    },
    btnSearchCailiao(t1,t2){
      if(t2==''){
        this.$router.push({
        name:'jicailist',
        params:{
          category1:t1
        }
      })
      }else{
        this.$router.push({
        name:'jicailist',
        params:{
          category1:t1,
          category2:t2
        }
      })
      }
    
    },
    //发布
    btnPublish(){
      if(!this.common.getSessionStorage('userInfo')){
        

       
        this.$msgbox.confirm('您还未登录, 是否去登录?', '提示', {
          confirmButtonText: '去登录',
          cancelButtonText: '继续浏览',
          type: 'warning'
        }).then(() => {
          window.location.replace(config.pchref)
        })
        return
      
      }else{
        this.$router.push({
        path:'/fabujicai'
      })
      }

    },
    //报名
    btnBaoming(id){
      if(!this.common.getSessionStorage('userInfo')){
        


        this.$msgbox.confirm('您还未登录, 是否去登录?', '提示', {
          confirmButtonText: '去登录',
          cancelButtonText: '继续浏览',
          type: 'warning'
        }).then(() => {
          window.location.replace(config.pchref)
        })
        return
      
      }else{
        this.$router.push({
        path:'/lijibaoming',
        query:{id}
      })
      }
    },
    //查看更多
    btnSeemore(){
   
      this.$router.push({
        path:'/jicailist'
      })
    },
    // ckxq(){
    //   if(this.activeName==1){
    //     this.$router.push({
    //       path:'/caigou'
    //     })
    //   }else{
    //     this.$router.push({
    //       path:'/zhaobiao'
    //     })
    //   }
    // },
  }
}
</script>
<style lang="scss" scoped>
 .gxjy{
.tuzuo{
  height: 200px;
  background: url("../../assets/jzcg/zuoce.png") no-repeat;
  background-size: 100% 100%;
  // padding:56px 38px;
  .tzt{
    color:#1266F9;
    font-size:25px;
    line-height: 36px;
    margin-left:38px;
    padding-top:56px;
    font-weight: bold;
  }
  .tzp{
    color:#62656B ;
    font-size:16px;
    line-height: 23px;
    margin-left:38px;
    padding-top:8px;
    width:300px;
  }
}
.tuyou{
  height:200px;
  background: url("../../assets/jzcg/youce.png") no-repeat;
  background-size: 100% 100%;
  .tyt{
    color:#1266F9;
    font-size:25px;
    line-height: 36px;
    margin-left:38px;
    padding-top:56px;
    font-weight: bold;
  }
  .tyt2{
    color:#62656B ;
    font-size:16px;
    line-height: 23px;
    margin-left:38px;
    padding-top:8px;
    width:270px;
  }
}
.neirong{
  .tt1{
  font-size:14px;
  // color:#1266F9 ;
  color:#1F2329 ;
  line-height: 30px;
}
  .tt2{
    color:#1D1D1D;
    font-size: 20px;
    line-height: 30px;
    font-weight: bold;
    margin-top:28px;
  }
  .fenge{
    border-top:1px solid #E6E6E6;margin-bottom:20px;margin-top:2px;
    width:720px;
  }
  .pp1{
    color:#42454C ;
    font-size:16px;
    font-weight: 500;
    font-weight: bold;
  }
  .pt1{
    color:#42454C;
    font-size:14px;
    line-height: 20px;
  }
  .jxd{
    background: url("../../assets/jzcg/juxingdi.png") no-repeat;
  background-size: 100% 100%;
  }
  .ellipsis {
  white-space: nowrap; /* 确保文本在一行内显示 */
  overflow: hidden; /* 隐藏超出容器的文本 */
  text-overflow: ellipsis; /* 使用省略号表示被截断的文本 */
}
}
  //////////////////////////
    background: #f5f5f5;
   /deep/ .el-button:hover{
     color: #0c8aff;
   }
   .bgf{
     background: #fff;
     position: relative;
   }
   .bgall{
     background: #fff;
     padding:35px 0;
   }
    .content{
      width: 1200px;
      margin: 0 auto;
      .wyrz{
        background: #409EFF;
        color: #fff;
        border-radius: 4px;
        padding:35px 20px;
        margin-top: 25px;
      }
    }
  }
</style>